"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _commonSaverLibrary = require("../libraries/commonSaverLibrary");

var _common = require("../common");

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var saveButtons, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, saveBtn;

    return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    saveButtons = document.querySelectorAll('.common-save-button');
                    _iteratorNormalCompletion = true;
                    _didIteratorError = false;
                    _iteratorError = undefined;
                    _context.prev = 4;
                    _iterator = (0, _getIterator3.default)(saveButtons);

                case 6:
                    if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                        _context.next = 15;
                        break;
                    }

                    saveBtn = _step.value;

                    if (!(saveBtn.alreadyRegisteredClick === true)) {
                        _context.next = 10;
                        break;
                    }

                    return _context.abrupt("return");

                case 10:

                    saveBtn.addEventListener('click', _commonSaverLibrary.commonSaverLibrary.saveCommon);
                    saveBtn.alreadyRegisteredClick = true;

                case 12:
                    _iteratorNormalCompletion = true;
                    _context.next = 6;
                    break;

                case 15:
                    _context.next = 21;
                    break;

                case 17:
                    _context.prev = 17;
                    _context.t0 = _context["catch"](4);
                    _didIteratorError = true;
                    _iteratorError = _context.t0;

                case 21:
                    _context.prev = 21;
                    _context.prev = 22;

                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }

                case 24:
                    _context.prev = 24;

                    if (!_didIteratorError) {
                        _context.next = 27;
                        break;
                    }

                    throw _iteratorError;

                case 27:
                    return _context.finish(24);

                case 28:
                    return _context.finish(21);

                case 29:
                    _context.next = 31;
                    return _common2.default.registerPhoneNumberValidation();

                case 31:
                case "end":
                    return _context.stop();
            }
        }
    }, _callee, this, [[4, 17, 21, 29], [22,, 24, 28]]);
}));
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/commonSaver.js
// module id = 1063
// module chunks = 1